import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { Flex } from '@magnetic/flex';
import { Skeleton } from '@magnetic/skeleton';
import TimeWeather from '../time-weather';
import BrandLogo from '../brand-logo';
import { useTranslation } from 'react-i18next';
const GreetingText = styled.span `
  font-family: 'Sora';
  font-weight: 400;
  font-size: 34px;
  font-size: 1.771vw;
  line-height: 48px;
  line-height: 4.444vh;
`;
export const LevelText = styled.span `
  font-family: 'Sora';
  font-weight: 300;
  font-size: 3vw;
  line-height: 3vw;
  width: 1000px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  height: 3.2vw;
`;
/**
 * Header component that displays a greeting message, a logo, and a title.
 * It also includes a widget container that shows the current time and weather.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.title - The title to be displayed in the header.
 *
 * @returns {JSX.Element} The rendered Header component.
 */
export function Header({ title }) {
    const { t } = useTranslation();
    return (_jsxs(Flex, Object.assign({ gap: 24 }, { children: [_jsxs(Flex, Object.assign({ direction: "verticle", grow: true, basis: 1250, justify: "center" }, { children: [_jsx(GreetingText, { children: t('building.welcome-to') }), _jsxs(Flex, Object.assign({ align: "center", gap: 24 }, { children: [_jsx(BrandLogo, {}), title.length > 0 ? (_jsx(LevelText, { children: title })) : (_jsx(Skeleton, { height: "sm", style: {
                                    width: '40%',
                                }, shade: "regular" }))] }))] })), _jsx(Flex, Object.assign({ grow: true, weight: 1, justify: "flex-end" }, { children: _jsx(TimeWeather, {}) }))] })));
}
